import { FormControl, InputLabel, Select, TextField, makeStyles } from '@material-ui/core';

import {
  ENTITY_STATUS_FILTERS,
  ENTITY_STATUS_FILTER_LABELS,
  EntityStatusFilter,
} from '../../../shared/constants/entity-status-filter.constants';
import { ALL_DELIVERY_CITY_ZONES } from '../../constants/delivery-city-filters.constants';
import { useLiveDeliveryZoneOptions } from '../../hooks/use-live-delivery-zone-options.hook';

const SEARCH_INPUT_ID = 'delivery-cities-search';
const ZONE_FILTER_INPUT_ID = 'delivery-cities-zone-filter';
const STATUS_FILTER_INPUT_ID = 'delivery-cities-status-filter';

interface DeliveryCitiesListFiltersProps {
  search: string;
  zoneFilter: string;
  statusFilter: EntityStatusFilter;
  onSearchChange: (value: string) => void;
  onZoneFilterChange: (value: string) => void;
  onStatusFilterChange: (value: EntityStatusFilter) => void;
}

const useStyles = makeStyles({
  filters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
  },
});

export function DeliveryCitiesListFilters({
  search,
  zoneFilter,
  statusFilter,
  onSearchChange,
  onZoneFilterChange,
  onStatusFilterChange,
}: DeliveryCitiesListFiltersProps) {
  const classes = useStyles();
  const { zoneOptions } = useLiveDeliveryZoneOptions();

  return (
    <section className={classes.filters}>
      <TextField
        id={SEARCH_INPUT_ID}
        size="small"
        label="Rechercher"
        type="text"
        variant="outlined"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <FormControl variant="outlined" size="small">
        <InputLabel htmlFor={ZONE_FILTER_INPUT_ID}>Zone</InputLabel>
        <Select
          native
          label="Zone"
          value={zoneFilter}
          inputProps={{ id: ZONE_FILTER_INPUT_ID }}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => onZoneFilterChange(event.target.value)}
        >
          <option value={ALL_DELIVERY_CITY_ZONES}>Toutes</option>
          {zoneOptions.map((zone) => (
            <option key={zone.id} value={zone.id}>
              {zone.name}
            </option>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small">
        <InputLabel htmlFor={STATUS_FILTER_INPUT_ID}>Statut</InputLabel>
        <Select
          native
          label="Statut"
          value={statusFilter}
          inputProps={{ id: STATUS_FILTER_INPUT_ID }}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            onStatusFilterChange(event.target.value as EntityStatusFilter)
          }
        >
          {ENTITY_STATUS_FILTERS.map((status) => (
            <option key={status} value={status}>
              {ENTITY_STATUS_FILTER_LABELS[status]}
            </option>
          ))}
        </Select>
      </FormControl>
    </section>
  );
}
